import { BaseInlineNotice as BaseInlineNotice$1 } from './base-inline-notice.js';
import { BaseInlineNoticeActions } from './base-inline-notice-actions.js';
import { BaseInlineNoticeContent } from './base-inline-notice-content.js';
import { BaseInlineNoticeContentContainer } from './base-inline-notice-content-container.js';
import { BaseInlineNoticeIcon } from './base-inline-notice-icon.js';
var BaseInlineNotice = Object.assign(BaseInlineNotice$1, {
  Actions: BaseInlineNoticeActions,
  Content: BaseInlineNoticeContent,
  ContentContainer: BaseInlineNoticeContentContainer,
  Icon: BaseInlineNoticeIcon
});
export { BaseInlineNotice };